import { getAPIClient } from 'api/axios'
import { DataService } from 'api/DataService'

import {
  DisputeDetailResponse,
  DisputesListResponse,
  UploadDocumentResponse
} from './types'

export class DisputesService {
  static async list(page = 1, per = 25): Promise<DisputesListResponse> {
    const response = await DataService({
      type: 'GET',
      url: `/v1/disputes?page=${page}&per=${per}`
    })
    return response.data
  }

  static async show(uuid: string): Promise<DisputeDetailResponse> {
    const response = await DataService({
      type: 'GET',
      url: `/v1/disputes/${uuid}`
    })
    return response.data
  }

  static async uploadDocument(
    uuid: string,
    file: File
  ): Promise<UploadDocumentResponse> {
    const formData = new FormData()
    formData.append('document', file)
    const response = await getAPIClient().post(
      `/v1/disputes/${uuid}/documents`,
      formData
    )
    return response.data
  }

  static async deleteDocument(
    uuid: string,
    docSignedId: string
  ): Promise<void> {
    await getAPIClient().delete(`/v1/disputes/${uuid}/documents/${docSignedId}`)
  }

  static async submit(uuid: string): Promise<DisputeDetailResponse> {
    const response = await DataService({
      type: 'POST',
      url: `/v1/disputes/${uuid}/submit`
    })
    return response.data
  }
}
